import * as Yup from 'yup'
import { Form,Row,Col } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999999;
            return true;
        }),
});

export const SalaryRequestSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
                <Form.Group className="mb-3"  controlId="formSalaryRequest">
                    <Form.Label>Gehaltswunsch jährlich</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Jährlichen Gehaltswunsch eingeben"
                        type="text"
                        name="salaryRequest"
                        value={values.salaryRequest || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.salaryRequest && !errors.salaryRequest}
                        isInvalid={touched.salaryRequest && errors.salaryRequest}
                        maxLength={9}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.salaryRequest}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3" controlId="formWorkTime">
                    <Form.Label>Gewünschte wöchentliche Arbeitszeit (nur bei Teilzeitoption einzutragen)</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Wöchentliche Arbeitszeit eingeben"
                        type="text"
                        name="workTime"
                        value={values.workTime || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.workTime && !errors.workTime}
                        isInvalid={touched.workTime && errors.workTime}
                        maxLength={2}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.workTime}
                    </Form.Control.Feedback>
                </Form.Group>
        </>
    );
};